import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import { callApi, fetchApiDataIfNeeded } from '../../../../actions/api'
import { apiResourceEndpoint } from '../../../../constants/routes'

import SHSForm from '../../../utils/shs-form'
import InputElement from '../../../utils/input'
import EditableDisplayField from '../../../utils/editable-display-field'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ALLERGEN_CONFIG } from '../../../../constants/allergen-config'

const mapStateToProps = (state) => {
    return {
        stateAllergens: state.adminAllergens.slice().sort((a, b) => {
            if (a.name > b.name) {
                return 1
            }
            return -1
        })
    }
}

const Allergens = ({ dispatch, stateAllergens }) => {
    const [showForm, setShowForm] = useState(false)
    const allergenOptions = Object.values(ALLERGEN_CONFIG).map(allergen => ({ value: allergen.icon, label: allergen.label }))

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('admin/allergens', 'LIST')))
    }, [dispatch])

    if (!stateAllergens) {
        return null
    }

    const handleDelete = (allergen) => {
        let deleteMe = window.confirm(`Are you sure you want to delete ${allergen.name}`)
        if (deleteMe) {
            dispatch(callApi(apiResourceEndpoint('admin/allergens', 'DELETE', allergen.id), {}, -1))
        }
    }

    const renderAllergens = () => {
        let allAllergens = []
        stateAllergens.forEach(allergen => {
            allAllergens.push(
                <div key={allergen.id} className="item">
                    <EditableDisplayField
                        label="Name"
                        display={allergen.name}
                        dataObj={allergen}
                        endpoint="admin/allergens"
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'text',
                            field: 'name'
                        }]} />
                    <EditableDisplayField
                        label="Description"
                        display={allergen.description}
                        dataObj={allergen}
                        endpoint="admin/allergens"
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'text',
                            field: 'description'
                        }]} />
                    <EditableDisplayField
                        label="Icon"
                        display={<FontAwesomeIcon icon={allergen.icon}/>}
                        dataObj={allergen}
                        endpoint="admin/allergens"
                        extraClass="field select"
                        inTable={true}
                        fields={[{
                            type: 'valueSelect',
                            field: 'icon',
                            options: allergenOptions
                        }]} />
                    <EditableDisplayField
                        label="Priority Level"
                        display={allergen.level}
                        dataObj={allergen}
                        endpoint="admin/allergens"
                        extraClass="field name"
                        inTable={true}
                        fields={[{
                            type: 'number',
                            field: 'level'
                        }]} />
                    <span className="remove" title="Delete" onClick={() => handleDelete(allergen)}>
                        <FontAwesomeIcon icon="times" />
                    </span>
                </div>
            )
        })
        return <div className="ticket-items">{allAllergens}</div>
    }

    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('admin/allergens', 'CREATE'), formData, formId))
    }

    const successFX = (itemId) => {
        setShowForm(false)
    }

    const renderAddForm = () => {
        if (!showForm) {
            return null
        }
        return (
            <div className="ticket-items">
                <div className="item">
                    <SHSForm submitFX={submitFX} successFX={successFX} showCancel={true} cancelAction={() => setShowForm(false)}>
                        <InputElement
                            id="name"
                            label="Name"
                            type="text"
                            extraClass="flex-50"
                            required />
                        <InputElement
                            id="description"
                            label="Description"
                            type="text"
                            extraClass="flex-50"
                        />
                        <InputElement
                            id="icon"
                            label="Icon"
                            type="valueSelect"
                            options={allergenOptions}
                            extraClass="flex-50"
                        />
                        <InputElement
                            id="level"
                            label="Priority Level"
                            type="number"
                            extraClass="flex-50"
                            required />
                    </SHSForm>
                </div>
            </div>
        )
    }

    const renderActionButton = () => {
        if (showForm) {
            return null
        }
        return (
            <div className="btn white bordered centered" onClick={() => setShowForm(true)}>
                Add Allergen +
            </div>
        )
    }

    return (
        <>
            {renderAllergens()}
            {renderAddForm()}
            {renderActionButton()}
        </>
    )
}

export default connect(mapStateToProps)(Allergens)
